<template>
  <div id="rectify">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.getUrlParam()

    // var vConsole = new VConsole()
    // console.log(vConsole)
  },
  $route: {
    //handler  第一次绑定不会监听
    handler: function (val, oldVal) {
      console.log(1996, val, oldVal)
    },
  },
  methods: {
    // 获取 url 参数
    getUrlParam() {
      let paramObj = {}
      let geturl = window.location.href
      let qrArr = geturl.substr(geturl.indexOf('?') + 1).split('&')
      qrArr.forEach(item => {
        paramObj[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
      })
      // console.log('paramObj', paramObj)
      this.$store.commit('rectify/setQueryData', paramObj)
    },
  },
}
</script>

<style lang="less" scoped>
body {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#rectify {
  height: 100%;
}
/deep/.van-nav-bar {
  position: fixed;
}
</style>
